import { useEffect, useRef } from 'react'
import { trackLead } from '../utils/metaPixel'
import {
  isWellFormedSid,
  markLeadSent,
  verifyTallySubmission,
  wasLeadAlreadySent,
} from '../utils/leadVerification'

/**
 * Envía Lead solo si:
 * 1. La URL trae un sid con formato válido (llega desde la redirección de Tally).
 * 2. El servicio de verificación confirma con la API de Tally que el envío existe y es reciente.
 * 3. Ese envío no se registró antes en este navegador.
 * 4. El visitante no bloqueó el seguimiento.
 * Después quita el sid de la URL para que recargar o compartir la página no repita el evento.
 */
export function useTallyLead() {
  const handled = useRef(false)

  useEffect(() => {
    if (handled.current) return
    handled.current = true

    const params = new URLSearchParams(window.location.search)
    const sid = params.get('sid')

    if (params.has('sid')) {
      params.delete('sid')
      const query = params.toString()
      window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}`)
    }

    if (!isWellFormedSid(sid) || wasLeadAlreadySent(sid)) return

    verifyTallySubmission(sid).then((result) => {
      if (result !== 'valid' || wasLeadAlreadySent(sid)) return
      if (trackLead(sid)) markLeadSent(sid)
    })
  }, [])
}
